<template>
    <el-dialog
        title="分配客户"
        :visible.sync="allocationDialog"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        custom-class="custom-form-dialog custom-allocation-dialog"
    >
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
            <el-form-item label="分配给" prop="allocator_uid">
                <el-select
                    placeholder="请输入或选择员工"
                    v-model="formData.allocator_uid"
                    :remote-method="getUserList"
                    filterable
                    remote
                    reserve-keyword
                >
                    <el-option
                        v-for="(userItem, userIndex) in userList"
                        :key="userIndex"
                        :value="userItem.uid"
                        :label="userItem.name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <template #label>
                    <span class="bold-text">下列客户可被分配</span>
                </template>
                <div class="select-company">
                    <p v-for="(companyItem, companyIndex) in selectedList" :key="companyItem.id">
                        {{ selectedList.length > 1 ? companyIndex + 1 + "." : ""
                        }}{{ companyItem.name && companyItem.name.value }}
                    </p>
                </div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { GetUserList, CustomerPublicAllocate } from "@/api";
export default {
    name: "CustomerAllocation",
    props: {
        allocationDialog: {
            type: Boolean,
            default: false,
        },
        allocationCustomerId: {
            type: Number,
            default: 0,
        },
        selectedList: {
            type: Array,
            default: [],
        },
        sea_id: "",
    },
    data() {
        return {
            dialogVisible: false,
            formLoading: true,
            formData: {
                allocator_uid: "",
            },
            formRules: {
                allocator_uid: [{ required: true, message: "请选择", trigger: "change" }],
            },
            userList: [],
            btnDisabled: false,
        };
    },
    created() {
        this.getUserList();
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:allocationDialog", false);
        },
        handleDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    this.btnDisabled = true;
                    this.formLoading = true;
                    const params = {
                        allocator_uid: this.formData.allocator_uid,
                        customer_ids: this.selectedList.map((item) => item.id),
                    };
                    CustomerPublicAllocate(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.$emit("update:allocationDialog", false);
                                this.$emit("updateCallback");
                            }
                            this.btnDisabled = false;
                            this.formLoading = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
        getUserList(keyword) {
            GetUserList({ keyword, type: "customer_seas", sea_id: this.sea_id })
                .then((res) => {
                    if (res.code === 200) {
                        this.userList = res.data || [];
                    }
                    this.formLoading = false;
                })
                .catch(() => {
                    this.formLoading = false;
                });
        },
    },
};
</script>
<style lang="scss">
.custom-allocation-dialog {
    .bold-text {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .select-company {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        max-height: 236px;
        overflow-y: scroll;
    }
}
</style>
